import { createMutation } from '@/utils/common.js'
import { getSearchPermission } from '@/utils/api/permission-verification.js'
const store = {
  namespaced: true,
  state: () => {
    return {
      accessData: null, // 用户会员信息
    }
  },
  actions: {
    // 重新请求会员信息
    async requestAccessData(ctx) {
      try {
        const res = await getSearchPermission()
        if(res.rspResult.bizCode === 200) {
          ctx.commit('SET_ACCESS_DATA', res.data)
        } else {
          ctx.commit('SET_ACCESS_DATA', null)
        }
      } catch (err) {
        console.error("❌ ~ file: permissionVerification.js:21 ~ requestAccessData ~ err:", err)
        ctx.commit('SET_ACCESS_DATA', null)
      }
    },
  },
}

store.mutations = createMutation(store.state())

export default store
